// React
import React from 'react';

// Packages

// Utilities
import { getYears } from 'utilities';
import { useLabels } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';
import { ResultsResearchDetails } from 'components/_cardContents/resultsResearch/resultsResearch';

const Name = CONSTANTS.RESULTS.RESEARCH;

const Choice = props => {
    return ResultChoice({
        Name,
        methods: 'Initiative_Result__c.Publication_Method__c',
        fieldName: 'Publication_Method__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Publication_Method__c',
                showDetails: mode.includes('details'),
            }}>
            <ResultsResearchDetails {...{ item, theme }} />
        </ResultDataCard>
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, pickList } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const {
            Publication_Method__c,
            Research_Importance__c,
            Year__c,
            Publisher__c,
            Author__c,
            DOI__c,
            URL__c,
            Publication_Title__c,
        } = formData;

        // Data for sf
        return {
            Publication_Method__c,
            Research_Importance__c,
            Year__c: Year__c?.length > 0 ? Year__c : null,
            Publisher__c,
            Author__c,
            DOI__c,
            URL__c,
            Publication_Title__c,
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'Select',
                name: 'Research_Importance__c',
                object: object.config(
                    'Initiative_Result__c.Research_Importance__c'
                ),
                options: pickList(
                    'Initiative_Result__c.Research_Importance__c'
                ),
            },
            {
                type: 'Select',
                name: 'Year__c',
                object: object.config('Initiative_Result__c.Year__c__Research'),
                options: getYears(),
            },
            {
                type: 'Text',
                name: 'Publisher__c',
                object: object.config('Initiative_Result__c.Publisher__c'),
                maxLength: 200,
            },
            {
                type: 'Text',
                name: 'Author__c',
                object: object.config('Initiative_Result__c.Author__c'),
                maxLength: 80,
            },
            {
                type: 'Text',
                name: 'DOI__c',
                object: object.config('Initiative_Result__c.DOI__c'),
                maxLength: 30,
            },
            {
                type: 'Text',
                name: 'URL__c',
                object: object.config('Initiative_Result__c.URL__c'),
                maxLength: 80,
            },
            {
                type: 'Text',
                name: 'Publication_Title__c',
                object: object.config(
                    'Initiative_Result__c.Publication_Title__c'
                ),
                maxLength: 200,
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ResultDetails({
        fields,
        fieldSuffix: '__Research',
        getItemData,
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const {
        Research_Importance__c,
        Year__c,
        Publisher__c,
        Author__c,
        DOI__c,
        URL__c,
        Publication_Title__c,
    } = utilities.results.get(id);

    // Choice
    form.setValue('Research_Importance__c', Research_Importance__c);

    form.setValue('Year__c', Year__c);
    form.setValue('Publisher__c', Publisher__c);
    form.setValue('Author__c', Author__c);
    form.setValue('DOI__c', DOI__c);
    form.setValue('URL__c', URL__c);
    form.setValue('Publication_Title__c', Publication_Title__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
